import Vue from "vue";
import * as MUTATIONS from "../config/constants/mutation-types";
import { merge, get } from "lodash";
import { reactivoProductosMap } from "@/config/constants";

export default {
  /**
   * Mutation llamada por el router
   * Ponemos la ruta en el state
   * @param {Object} state
   * @param {Object} payload
   */
  [MUTATIONS.ON_ROUTE]: (state, payload) => {
    Vue.set(state, "route", payload);
  },
  /**
   * Mostrar u ocultar el loader
   * @param {Object} context
   * @param {Boolean} payload estado
   */
  [MUTATIONS.ON_IS_LOADING]: (state, payload) => {
    Vue.set(state, "isLoading", !!payload);
  },
  /**
   * Mostrar u ocultar el loader
   * @param {Object} context
   * @param {Boolean} payload estado
   */
  [MUTATIONS.ON_GET_CA]: (state, payload) => {
    if (
      get(payload, "status", undefined) === "OK" &&
      get(payload, "respuesta", undefined) !== undefined
    ) {
      const carroAbandonado = JSON.parse(get(payload, "respuesta.datos", "{}"));
      Vue.set(state, "paso2", {
        facturacionUltimoBalance: carroAbandonado.facturacionUltimoBalance,
        facturacionAnteriorBalance: carroAbandonado.facturacionAnteriorBalance,
        resultadoOperativo: carroAbandonado.resultadoOperativo,
        resultadoFinal: carroAbandonado.resultadoFinal,
        patrimonioNeto: carroAbandonado.patrimonioNeto
      });
    }
  },
  /**
   * Mutation disparadas por el
   * step navigator para avanzar pasos
   * Cada action guarda el paso
   * actual en el store
   * @param {Object} state
   */
  [MUTATIONS.ON_LANDING]: (state, payload) => {
    Vue.set(state, "landing", payload);
  },
  [MUTATIONS.ON_PASO_1]: (state, payload) => {
    Vue.set(state, "paso1", payload);
  },
  [MUTATIONS.ON_PASO_1_SUCCESS]: (state, payload) => {
    Vue.set(state, "responseConsulta", payload);
  },
  [MUTATIONS.ON_PASO_2]: (state, payload) => {
    Vue.set(state, "paso2", payload);
  },
  [MUTATIONS.ON_PASO_2_SUCCESS]: (state, payload) => {
    let mergedPayload = merge({}, payload, {
      respuesta: {
        oferta: {
          montoMaximo: parseInt(
            get(payload, "respuesta.oferta.montoMaximo", "")
          ),
          montoLargoPlazo: parseInt(
            get(payload, "respuesta.oferta.montoLargoPlazo", "")
          )
        }
      }
    });
    Vue.set(state, "responseOferta", mergedPayload);
  },
  [MUTATIONS.ON_PASO_3]: (state, payload) => {
    Vue.set(state, "paso3", payload);
  },
  [MUTATIONS.ON_PASO_4]: (state, payload) => {
    Vue.set(state, "paso4", payload);
  },
  [MUTATIONS.ON_GRACIAS]: (state, payload) => {
    Vue.set(state, "gracias", payload);
  },
  [MUTATIONS.ADOBE_APP_STARTED]: (state, payload) => {
    Vue.set(state, "trackClickElement", payload);
  },
  [MUTATIONS.ADOBE_APP_ON_CLICK_START]: (state, payload) => {
    Vue.set(state, "trackOnClickStart", payload);
  },
  [MUTATIONS.ADOBE_ABRIR_CUENTA]: () => {},
  [MUTATIONS.ADOBE_INTERNAL_LINK]: () => {},
  [MUTATIONS.ADOBE_PAGEVIEW]: () => {},
  [MUTATIONS.ON_IS_EXCEEDED]: (state, payload) => {
    Vue.set(state, "isExceeded", payload);
  },
  [MUTATIONS.ON_MOCK]: (state, payload) => {
    Vue.set(state, "mock", payload);
  },

  /** Reactivo Web */
  [MUTATIONS.ON_REACTIVO_PASO1]: (state, payload) => {
    Vue.set(state, "isExceeded", false);
    Vue.set(state, "reactivo", merge({}, state.reactivo, { paso1: payload }));
  },
  [MUTATIONS.ON_REACTIVO_EXCEDIDO]: state => {
    Vue.set(state, "isExceeded", true);
  },
  [MUTATIONS.ON_REACTIVO_OFERTA]: (state, payload) => {
    const { ofertaProductos } = payload.respuesta;
    const maximosOferta = {};
    for (let index = 0; index < ofertaProductos.length; index++) {
      const element = ofertaProductos[index];
      maximosOferta[reactivoProductosMap[element.codproducto]] = Number(
        element.importeMax
      );
    }
    // Hardcodeamos máximo de cheques
    maximosOferta["descuentoCheques"] = Number(
      get(payload, "respuesta.importe", 0)
    );

    const oferta = {
      cuit: get(state, "reactivo.paso1.cuit", ""),
      razonSocial: get(payload, "respuesta.razonSo", ""),
      maximosOferta: {
        oferta: Number(get(payload, "respuesta.importe", 0)),
        ...maximosOferta
      }
    };
    Vue.set(state, "reactivo", merge({}, state.reactivo, { oferta }));
  },
  [MUTATIONS.ON_CONFIRMACION_SUCURSAL]: (state, payload) => {
    Vue.set(state.reactivo, "confirmacionSucursal", payload);
  },

  /** AGRO */
  [MUTATIONS.ON_VALIDAR_CUIT_AGRO]: (state, response) => {
    Vue.set(state, "cuitAgroValidado", response);
  },
  [MUTATIONS.ON_AGRO_ES_CLIENTE]: (state, value) => {
    Vue.set(state, "agroEsCliente", value);
  },
  [MUTATIONS.ON_OFERTA_AGRO]: (state, response) => {
    Vue.set(state, "ofertaAgro", response);
  },

  /**
   * Mutation que permite a Adobe Target inyectar en el store
   * el código de la actividad que debe seleccionarse
   * @uso (desde afuera): BBVA_TC.$store.dispatch('setAdobeTargetExperience', 'AR062019_B')
   */
  [MUTATIONS.ON_ADOBE_TARGET_EXPERIENCE]: (state, payload) => {
    Vue.set(state, "adobeTargetExperience", payload);
  },

  [MUTATIONS.ON_GENERAR_OTP_SUCCESS](state, payload) {
    state.responseGenerarOTP = payload;
  },

  [MUTATIONS.SET_AGRO_DATA_FIELD]: (state, { key, value }) => {
    state.agroData[key] = value;
  },

  [MUTATIONS.SET_TELEFONO_VERIFICACION]: (state, value) => {
    state.telefonoVerificado = value;
  },

  [MUTATIONS.SET_EMAIL_VERIFICACION]: (state, value) => {
    state.emailVerificado = value;
  },
  /**
   * Setear datos del error de Agro en el store
   * @param {Object} state
   * @param {Object} payload Datos del error
   */
  [MUTATIONS.SET_AGRO_ERROR]: (state, payload) => {
    Vue.set(state, "agroError", payload);
  },

  /**
   * Limpiar datos del error de Agro
   * @param {Object} state
   */
  [MUTATIONS.CLEAR_AGRO_ERROR]: state => {
    Vue.set(state, "agroError", {
      title: "",
      subtitle: "",
      image: "",
      hasAction: false,
      action: null,
      actionPayload: null,
      returnRoute: null,
      successAction: null,
      tituloMaxIntentos: "",
      subtituloMaxIntentos: ""
    });
  }
};
